import PrivateLayout from 'layouts/PrivateLayout';
import SettingLayout from 'layouts/SettingLayout';
import ShopLayout from 'layouts/ShopLayout';
import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './auth/pages/Login';
import CustomerLayout from './customer/Layout';
import NotFoundPage from './NotFound';
import CashierPage from './POS/Cashier';

// const LoginPage = React.lazy(() => import('./auth/pages/Login'));
import POSCustomerLayout from 'layouts/POSCustomerLayout';
import useInitSocket, { SocketContext } from './POS/Cashier/hooks/useSocket';
import ReportLayout from './report/Layout';
import GeneralConfigLayout from './settings/general_configuration/layout';
import TicketsLayout from './tickets/Layout';
const POSCustomerViewDetailHome = React.lazy(() => import('./POS/Customer/Home'));
const POSCustomerViewDetail = React.lazy(() => import('./POS/Customer'));
const POSCustomerQRViewDetail = React.lazy(() => import('./POS/Customer/QRPayment'));
const POSCustomerQRPaymentMultipleViewDetail = React.lazy(() => import('./POS/Customer/QRPaymentMultiple'));
const SettingStaffListPage = React.lazy(
  () => import('./settings/staff/pages/StaffList')
);
const SettingStaffDetailPage = React.lazy(
  () => import('./settings/staff/pages/StaffDetail')
);
const SettingProductListPage = React.lazy(
  () => import('./settings/product/pages/ProductList')
);
const StoreSelectionPage = React.lazy(
  () => import('./auth/pages/StoreSelection')
);
const CashDiscountPage = React.lazy(
  () => import('./settings/general_configuration/pages/cash_discount')
);
const FeeCreditCardPage = React.lazy(
  () => import('./settings/general_configuration/pages/fee_credit_card')
);
const LoyaltyPage = React.lazy(
  () => import('./settings/general_configuration/pages/loyalty')
);
const PromotionsPage = React.lazy(
  () => import('./settings/general_configuration/pages/promotions')
);
const TaxPage = React.lazy(
  () => import('./settings/general_configuration/pages/tax')
);
const ClosedTickets = React.lazy(() => import('./tickets/pages/Closed'));
const VoidedTickets = React.lazy(() => import('./tickets/pages/Voided'));
const RefundedTickets = React.lazy(() => import('./tickets/pages/Refunded'));
const DeletedTickets = React.lazy(() => import('./tickets/pages/Deleted'));
const TicketDetail = React.lazy(() => import('./tickets/pages/TicketDetail'));
const PrintTicketDetail = React.lazy(
  () => import('./tickets/pages/Print/PrintTicketDetail')
);
const GiftCardListPage = React.lazy(
  () => import('./gift-card/pages/GiftCardList')
);
const GiftCardDetails = React.lazy(
  () => import('./gift-card/pages/GiftCardDetails')
);

const SupplierListPage = React.lazy(
  () => import('./settings/supplier/pages/SupplierListPage')
);

const CustomerListPage = React.lazy(
  () => import('./customer/pages/CustomerList')
);
const CustomerDetail = React.lazy(
  () => import('./customer/pages/CustomerDetail')
);
const ReportRevenuePage = React.lazy(() => import('./report/pages/Revenue'));
const ReportPaymentMethodPage = React.lazy(
  () => import('./report/pages/PaymentMethod')
);
const ReportInventoryPage = React.lazy(
  () => import('./report/pages/Inventory')
);
const SummarySingleDate = React.lazy(
  () => import('./report/pages/Prints/pages/SummarySingleDate')
);
const SummaryRangeDate = React.lazy(
  () => import('./report/pages/Prints/pages/SummaryRangeData')
);
const ProductDetail = React.lazy(() => import('./report/pages/ProductDetail'));
const ProductDetailSingleDate = React.lazy(
  () => import('./report/pages/Prints/pages/ProducDetailSingleDate')
);
const ProductDetailRangeDate = React.lazy(
  () => import('./report/pages/Prints/pages/ProductDetailRangeDate')
);
const PaymentMethodPrint = React.lazy(
  () => import('./report/pages/Prints/pages/PaymentMethod')
);
const InventorySummaryPrint = React.lazy(
  () => import('./report/pages/Prints/pages/InventorySummary')
);
const CreditCardPage = React.lazy(
  () => import('./credit_card/pages/CreditCard')
);
const ReportProductSale = React.lazy(
  () => import('./report/pages/ProductSale')
);
const HomePage = React.lazy(
  () => import('./dashboard/HomePage')
);

const TicketReceiptPreview = React.lazy(() => import('./POS/Receipts/TicketReceipts/Preview'));

const ProductBarcodePrintPreview = React.lazy(() => import('./settings/product/pages/ProductBarcodePrintPreview'));

const ReferralConfigScreen = React.lazy(() => import('./settings/general_configuration/pages/referral'));

const RootScreens = () => {
  const socketContext = useInitSocket();
  return (
    <SocketContext.Provider value={socketContext}>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route index path='/' element={<LoginPage />} />
          <Route index path='/login' element={<LoginPage />} />
          <Route path='' element={<PrivateLayout />}>
            <Route path='stores' element={<StoreSelectionPage />} />
            <Route path='store/:shop_id' element={<ShopLayout />}>
              <Route index path='home' element={<HomePage />} />
              <Route index path='' element={<CashierPage />} />
              <Route path='setting' element={<SettingLayout />}>
                <Route path='staff' element={<SettingStaffListPage />} />
                <Route path='customer' element={<CustomerLayout />}>
                  <Route path='' element={<CustomerListPage />} />
                  <Route
                    path=':customer_id/detail'
                    element={<CustomerDetail />}
                  />
                </Route>
                <Route
                  path='general_configuration'
                  element={<GeneralConfigLayout />}
                >
                  <Route index element={<TaxPage />} />
                  <Route path='cash_discount' element={<CashDiscountPage />} />
                  <Route
                    path='fee_credit_cash'
                    element={<FeeCreditCardPage />}
                  />
                  <Route path='loyalty' element={<LoyaltyPage />} />
                  <Route path='referral' element={<ReferralConfigScreen />} />
                </Route>
                <Route path='gift-card'>
                  <Route path='' element={<GiftCardListPage />} />
                  <Route
                    path='details/:gift_card_id'
                    element={<GiftCardDetails />}
                  />
                </Route>
                <Route path='supplier' element={<SupplierListPage />} />
              </Route>
              <Route path='product' element={<SettingProductListPage />} />
              <Route path='product/:product_name/:barcode/:quantity/:price' element={<ProductBarcodePrintPreview />} />
              <Route path='report' element={<ReportLayout />}>
                <Route index element={<ReportRevenuePage />} />
                <Route path='sale' element={<ReportProductSale />} />
                <Route
                  path='payment-method'
                  element={<ReportPaymentMethodPage />}
                />
                <Route path='inventory' element={<ReportInventoryPage />} />
                <Route
                  path='products/:product_id'
                  element={<ProductDetail />}
                />
                <Route path='print'>
                  <Route
                    path='summary/single-date'
                    element={<SummarySingleDate />}
                  />
                  <Route
                    path='summary/range-date'
                    element={<SummaryRangeDate />}
                  />
                  <Route
                    path='products/single-date/:product_id'
                    element={<ProductDetailSingleDate />}
                  />
                  <Route
                    path='products/range-date/:product_id'
                    element={<ProductDetailRangeDate />}
                  />
                  <Route
                    path='payment-method'
                    element={<PaymentMethodPrint />}
                  />
                  <Route
                    path='inventory-summary'
                    element={<InventorySummaryPrint />}
                  />
                </Route>
              </Route>
              <Route
                path='setting/staff/:staff_id'
                element={<SettingStaffDetailPage />}
              />
              <Route path='ticket' element={<TicketsLayout />}>
                <Route index element={<ClosedTickets />} />
                <Route path='voided' element={<VoidedTickets />} />
                <Route path='refunded' element={<RefundedTickets />} />
                <Route path='deleted' element={<DeletedTickets />} />
              </Route>
              <Route
                path='ticket/:ticket_id/detail'
                element={<TicketDetail />}
              />
              <Route
                path='ticket/:ticket_id/print'
                element={<PrintTicketDetail />}
              />
              <Route path='promotions' element={<PromotionsPage />} />
              <Route path='credit-card' element={<CreditCardPage />} />
            </Route>
            <Route path='store/:shop_id/pos-cs' element={<POSCustomerLayout />}>
              <Route index path='' element={<POSCustomerViewDetailHome />} />
              <Route path='bill/:bill_id' element={<POSCustomerViewDetail />} />
              <Route path='bill/:bill_id/qr/:method' element={<POSCustomerQRViewDetail />} />
              <Route path='bill/:bill_id/qr-multiple/:method' element={<POSCustomerQRPaymentMultipleViewDetail />} />
              <Route path='bill-preview/:bill_id' element={<TicketReceiptPreview />} />
            </Route>
            <Route
              path='setting/staff/:staff_id'
              element={<SettingStaffDetailPage />}
            />
          </Route>
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </SocketContext.Provider>
  );
};

export default RootScreens;
